import { getMapAddressData, addFirmWithDestination, reportAnalytics, reportWaitForLogin } from "~/report/util";
import { isPointInStatePolygon } from "~/util/state-polygon";
import { getMapErrorOptions, getAddPlaceOptions, getMapErrorOnUpdate } from "~/report/options";
import Report from "~/report";
import { _ } from "~/i18n";
import { getLocation } from "~/whereami";

function createContextMenu(caption: string, onClick: (scope: any) => void): any {
	function ContextMenu() {
		/* eslint-disable no-invalid-this */
		SMap.Control.ContextMenu.Item.call(this, caption);
		this.getContainer().setAttribute("data-log-ignore", "1");
	}

	ContextMenu.prototype = {
		...SMap.Control.ContextMenu.Item.prototype,
	};

	// eslint-disable-next-line func-names
	ContextMenu.prototype.click = function (event, menu) {
		menu.close();
		onClick(this);
	};

	return new ContextMenu();
}

// nahlasit chybu na mape
export function getReportMapErrorContextItem() {
	return createContextMenu(_("report.mapError"), async () => {
		reportAnalytics({
			text: "Chyba v mapě",
			origin: "menu",
			type: "mistake",
		});

		await reportWaitForLogin();

		const report = new Report(getMapErrorOptions("menu"));

		report.setOnUpdate(getMapErrorOnUpdate);
		report.open();
	});
}

// pridat firmu
export function getReportAddFirmContextMenu() {
	return createContextMenu(_("report.addFirm"), scope => {
		const wgsCoords = scope._coords.toWGS84();

		isPointInStatePolygon(wgsCoords[0], wgsCoords[1], {
			cs: true,
		}).then(isCzechia => {
			reportAnalytics({
				text: "Přidat svou firmu",
				origin: "menu",
				type: isCzechia ? "goToFirmy" : "addOsmFirm",
			});
			addFirmWithDestination(isCzechia, {
				origin: "menu",
				type: isCzechia ? "missingPlace" : "addOsmFirm",
				cz: isCzechia ? 1 : 0,
			}, {}, {
				lon: wgsCoords[0],
				lat: wgsCoords[1],
			});
		}, () => {});
	});
}

// pridat misto
export function getReportPoiContextItem() {
	return createContextMenu(_("report.addPlace"), async scope => {
		try {
			// nove nechceme whereami ale pouze souradnice kliku
			const wgsCoords = scope._coords.toWGS84();
			const data = {
				source: "coor",
				id: `${wgsCoords[0]},${wgsCoords[1]}`,
				coords: scope._coords,
				gpsCoords: scope._coords,
				label: scope._coords.toWGS84(2).join(", "),
			};
			const isCzechia = await isPointInStatePolygon(wgsCoords[0], wgsCoords[1], {
				cs: true,
			});

			const addressData = getMapAddressData(data);

			reportAnalytics({
				text: "Přidat chybějící místo",
				origin: "menu",
				type: "missingPlace",
				cz: isCzechia ? 1 : 0,
			});

			await reportWaitForLogin();

			const report = new Report(getAddPlaceOptions({
				values: {
					"name": data.label,
					"address": data.label,
					"address-data": addressData,
				},
				analytics: {
					type: "missingPlace",
					origin: "menu",
					cz: isCzechia ? 1 : 0,
				},
				coords: {
					lon: wgsCoords[0],
					lat: wgsCoords[1],
				},
			}));

			report.open();
		} catch (exc) {
			/* eslint-disable no-console */
			console.log(exc);
		}
	});
}
